export default __webpack_public_path__ + "static/media/img_file.683c4315.png";